module.exports = __webpack_public_path__ + "static/c-CAguas-17be243db86b7a49685978d8f6c7cddd.jpg";